// スキルの初期値（1件分）
// スキルID・名前・経験年数・レベル・表示フラグを含む
export const defaultSkill = {
  skill_id: null,
  skill_name: "",
  experience_year: "",
  level: "",
  visible_flag: true,
};

// 工程の初期値（1件分）
export const defaultOperation = {
  operation_id: null,
  experience_year: "",
};

// ポジションの初期値（1件分）
export const defaultRole = {
  role_id: null,
  experience_year: "",
};

// 工程の初期値（UI表示用）
// 要件定義・基本設計・詳細設計・実装・テスト・保守運用の6工程分
export const initialOperationExperience = [
  { checked: false, years: "" },
  { checked: false, years: "" },
  { checked: false, years: "" },
  { checked: false, years: "" },
  { checked: false, years: "" },
  { checked: false, years: "" },
];

// プロジェクト：フォーム初期値を返す関数（ユーザーIDを引数に）
export const getDefaultProjectFormValues = (currentUserId) => ({
  publish_start_date: "",
  publish_end_date: "",
  name: "",
  description: "",
  title: "",
  work_start_date: "",
  work_end_date: "",
  price_min: "",
  price_max: "",
  workload_min: "",
  workload_max: "",
  work_style: "on_site",
  prefecture_ids: [],
  commercial_flow: "end_client_company",
  commercial_flow_detail: "",
  interview_count: "",
  remark: "",
  published_flag: false,
  project_manager_id: currentUserId,
  skills: [{ ...defaultSkill }],
  operations: [{ ...defaultOperation }],
  roles: [{ ...defaultRole }],
  skill_detail: "",
  operation_detail: "",
  role_detail: "",
  long_term_flag: false,
});

// 求人：フォーム初期値を返す関数（ユーザーIDを引数に）
export const getDefaultJobFormValues = (currentUserId) => ({
  publish_start_date: "",
  publish_end_date: "",
  name: "",
  description: "",
  title: "",
  employment_type: "full_time",
  joining_date: "",
  price_min: "",
  price_max: "",
  prefecture_ids: [],
  interview_count: "",
  remark: "",
  published_flag: false,
  job_manager_id: currentUserId,
  skills: [{ ...defaultSkill }],
  operations: [{ ...defaultOperation }],
  roles: [{ ...defaultRole }],
  skill_detail: "",
  operation_detail: "",
  role_detail: "",
});
